import { Pipe, PipeTransform } from '@angular/core';
import {
  AFIKIM_ICON,
  BET_SHEMESH_EXPRESS_ICON,
  CARMELIT_ICON,
  DAN_BEER_SHEVA_ICON,
  DAN_DROM_ICON,
  DAN_ICON,
  EGGED_DEREK_ICON,
  EGGED_ICON,
  EILOT_ICON,
  ELECTRA_AFIKIM_ICON,
  ES_BUSSES_ICON,
  EXTRA_ICON,
  GALIM_ICON,
  GB_TOURS_ICON,
  GOLAN_ICON,
  JERUSALEM_ABU_TOR_UNIFIED_ICON,
  JERUSALEM_ALLAWAST_UNIFIED_ICON,
  JERUSALEM_MOUNT_OF_OLIVES_ICON,
  JERUSALEM_RAMALLAH_UNIFIED_ICON,
  JERUSALEM_SOUTH_UNIFIED_ICON,
  JERUSALEM_SUR_BAHER_UNIFIED_ICON,
  KAVIM_ICON,
  KFIR_ICON,
  METRO_KAV_TAXI_ICON,
  METROPOLIN_ICON,
  NATIV_EXPRESS_ICON,
  ODELIA_TAXI_ICON,
  RAHBALIT_ICON,
  RIDES_AND_TOURS_ICON,
  SHAM_ICON,
  SUPER_BUS_ICON,
  TEVEL_ICON,
  TNUFA_ICON,
  TRAIN_ICON,
  UNITED_TOURS_ICON,
  DAN_NETIVIM_ICON,
  eAgency
} from '../constants/agencies.constants';

@Pipe({
    name: 'agencyLogo',
    standalone: false
})
export class AgencyLogoPipe implements PipeTransform {

  transform(agencyId: number | string): string {
    if (!agencyId) return null;
    if (typeof (agencyId) === "string") agencyId = parseInt(agencyId);

    switch (agencyId) {
      case eAgency.DAN:
        return DAN_ICON;
      case eAgency.EGGED:
        return EGGED_ICON;
      case eAgency.EGGED_DEREK:
        return EGGED_DEREK_ICON;
      case eAgency.ELECTRA_AFIKIM:
        return ELECTRA_AFIKIM_ICON;
      case eAgency.RIDES_AND_TOURS:
        return RIDES_AND_TOURS_ICON;
      case eAgency.KAVIM:
        return KAVIM_ICON;
      case eAgency.AFIKIM:
        return AFIKIM_ICON;
      case eAgency.METROPOLIN:
        return METROPOLIN_ICON;
      case eAgency.CARMELIT:
        return CARMELIT_ICON;
      case eAgency.DAN_SOUTH:
        return DAN_DROM_ICON;
      case eAgency.RAHBALIT:
        return RAHBALIT_ICON;
      case eAgency.TEVEL:
        return TEVEL_ICON;
      case eAgency.TRAIN:
        return TRAIN_ICON;
      case eAgency.DAN_BEER_SHEVA:
        return DAN_BEER_SHEVA_ICON;
      case eAgency.EILOT:
        return EILOT_ICON;
      case eAgency.EXTRA:
        return EXTRA_ICON;
      case eAgency.EXTRA_JERUSALEM:
        return EXTRA_ICON;
      case eAgency.GALIM:
        return GALIM_ICON;
      case eAgency.GB_TOURS:
        return GB_TOURS_ICON;
      case eAgency.GOLAN:
        return GOLAN_ICON;
      case eAgency.KFIR:
        return KFIR_ICON;
      case eAgency.METRO_KAV_TAXI:
        return METRO_KAV_TAXI_ICON;
      case eAgency.NATIV_EXPRESS:
        return NATIV_EXPRESS_ICON;
      case eAgency.ODELIA_TAXI:
        return ODELIA_TAXI_ICON;
      case eAgency.BET_SHEMESH_EXPRESS:
        return BET_SHEMESH_EXPRESS_ICON;
      case eAgency.SHAM:
        return SHAM_ICON;
      case eAgency.SUPER_BUS:
        return SUPER_BUS_ICON;
      case eAgency.TNUFA:
        return TNUFA_ICON;
      case eAgency.UNITED_TOURS:
        return UNITED_TOURS_ICON;
      case eAgency.ES_BUSSES:
        return ES_BUSSES_ICON;
      case eAgency.JERUSALEM_ALLAWAST_UNIFIED:
        return JERUSALEM_ALLAWAST_UNIFIED_ICON;
      case eAgency.JRUSALEM_RAMALLAH_UNIFIED:
        return JERUSALEM_RAMALLAH_UNIFIED_ICON;
      case eAgency.JERUSALEM_ABU_TOR_UNIFIED:
        return JERUSALEM_ABU_TOR_UNIFIED_ICON;
      case eAgency.JERUSALEM_MOUNT_OF_OLIVES:
        return JERUSALEM_MOUNT_OF_OLIVES_ICON;
      case eAgency.JERUSALEM_SOUTH_UNIFIED:
        return JERUSALEM_SOUTH_UNIFIED_ICON;
      case eAgency.JERUSALEM_SUR_BAHER_UNIFIED:
        return JERUSALEM_SUR_BAHER_UNIFIED_ICON;
      case eAgency.DAN_NETIVIM:
        return DAN_NETIVIM_ICON;
      default:
        return "";
    }
  }

}

